// extracted by mini-css-extract-plugin
module.exports = {"feedCard":"OaeoHVs"};